import Box from '@mui/material/Box'
import DelDocDialog from 'components/AppDialogs/DelDocDialog'
import FullHeightFlexContainer from 'components/ui/FullHeightFlexContainer'
import { DEFAULT_PER_PAGE, MODE } from 'config'
import { DocListItem } from 'entities/Documents'
import { useEffect, useState, useCallback } from 'react'
import { useLoaderData, useParams, useSearchParams } from 'react-router-dom'

import DeletedControlArea from './ListPage/DeletedControlArea'
import DocumentsList from './ListPage/DocumentsList'

export default function Deleted() {
  const [selectedIDs, setSelectedIDs] = useState<string[]>([])
  const [openDelDialog, setOpenDelDialog] = useState(false)
  const setSearchParams = useSearchParams()[1]

  const mode = useParams().mode

  const { documents, total, params } =
    (useLoaderData() as { documents: DocListItem[]; total: number; params?: any }) || undefined
  const page = parseInt(params?.page) || 0
  const perPage = parseInt(params?.perPage) || DEFAULT_PER_PAGE

  useEffect(() => {
    setSelectedIDs(
      (sIDs) => documents?.map((d) => d.objectID).filter((id) => sIDs.includes(id)) || [],
    )
  }, [documents])

  const reloadDocs = useCallback(() => {
    setSearchParams((s) => s)
  }, [setSearchParams])

  return (
    <FullHeightFlexContainer>
      <Box>
        <h2>ごみ箱 {mode === MODE.VERIFY && '(ベリファイ)'}</h2>
        <DeletedControlArea selectedIDs={selectedIDs} setOpenDelDialog={setOpenDelDialog} />
      </Box>
      <Box style={{ overflow: 'hidden' }}>
        <DocumentsList
          selectedIDs={selectedIDs}
          setSelectedIDs={setSelectedIDs}
          documents={documents}
          total={total}
          page={page}
          perPage={perPage}
        />
      </Box>
      {documents && (
        <>
          <DelDocDialog
            open={openDelDialog}
            setOpenDialog={setOpenDelDialog}
            selectedIDs={selectedIDs}
            documents={documents}
            reloadDocs={(ids: string[]) => ids.length > 0 && reloadDocs()}
            hard
          />
        </>
      )}
    </FullHeightFlexContainer>
  )
}
